import styled from 'styled-components'
import { Flex } from 'antd'
import { mediaMax } from '@/app/styles/breakpoints'

export const PaginationContainer = styled(Flex)`
  && {
    ${mediaMax.sm} {
      /* position: relative;
      padding-top: 48px;
      justify-content: center;
      .ant-pagination-total-text {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-100%);
      }
      .ant-pagination-options {
        position: absolute;
        right: 0;
        top: 0;
      } */
      .ant-pagination {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        width: 100%;
      }

      .ant-pagination-total-text {
        flex: 1;
      }

      .ant-pagination-options {
        margin-left: auto;
      }

      .ant-pagination::after {
        content: '';
        width: 100%;
        order: 2;
      }

      .ant-pagination-prev,
      .ant-pagination-item,
      .ant-pagination-next {
        order: 3;
        width: 32px;
        height: 32px;
      }

      .ant-pagination {
        justify-content: center;
      }

      .ant-pagination-total-text,
      .ant-pagination-options {
        width: 50%;
        flex: 0 0 45%;
      }
      .ant-pagination-total-text {
        text-align: right;
        padding-right: 8px;
      }
      .ant-pagination-options {
        margin-left: 8px;
        margin-right: 0;
      }
    }
    .ant-pagination-prev,
    .ant-pagination-next {
      padding: 0;
      display: flex;
      ${mediaMax.sm} {
        margin-inline-end: 0;
      }
      div {
        width: 100%;
        justify-content: center;
      }
    }
    svg {
      fill: currentColor;
    }
    .ant-pagination-disabled {
      opacity: 0.25;
    }
    li:not(.ant-pagination-disabled):not(.ant-pagination-total-text):not(
        .ant-pagination-options
      ) {
      color: ${(props) => props.theme.colors.primary};
    }
    .ant-pagination-item-active {
      background-color: ${(props) => props.theme.colors.primary};
      ${mediaMax.sm} {
        margin: 0 8px;
      }
      a {
        color: white;
      }
    }
    .ant-pagination-total-text {
      order: -2;
      line-height: 32px;
      margin-right: 0;
      white-space: nowrap;
      span {
        color: ${(props) => props.theme.colors.cardDescription};
      }
      b {
        font-weight: 600;
      }
    }
    .ant-pagination-options {
      order: -1;
      margin-right: 16px;
      white-space: nowrap;
      @media only screen and (max-width: 576px) {
        display: inline-block;
        margin-right: 0;
      }
      &::before {
        content: 'Показывать: ';
        color: ${(props) => props.theme.colors.cardDescription};
      }
      .ant-select {
        min-width: 60px;
        .ant-select-selection-search {
          display: none;
        }
        .ant-select-arrow {
          .anticon {
            width: 16px;
            height: 16px;
            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzcxOF8xNTY1NykiPgo8cGF0aCBkPSJNMTEuMDYgNS43MjY1Nkw4IDguNzc5OUw0Ljk0IDUuNzI2NTZMNCA2LjY2NjU2TDggMTAuNjY2NkwxMiA2LjY2NjU2TDExLjA2IDUuNzI2NTZaIiBmaWxsPSIjNTI1MjUyIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfNzE4XzE1NjU3Ij4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=);
            svg {
              display: none;
            }
          }
        }
      }
    }
    .ant-pagination-item:not(.ant-pagination-item-active),
    .ant-pagination-jump-next,
    .ant-pagination-jump-prev {
      ${mediaMax.md} {
        display: none;
      }
    }
  }
`

export const PagerButton = styled(Flex)`
  && {
    /* color: #1d4ed8; */
    font-weight: 500;
    cursor: pointer;

    &:hover {
      color: #2563eb;
    }

    .anticon {
      transition: transform 0.2s;
    }

    &:hover .anticon {
      transform: translateX(2px);
    }
  }
`
